import { Dispatch, SetStateAction, useEffect } from 'react';
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import InputFloating from '@/components/atoms/InputFloating';

import { ScrollArea } from "@/components/ui/scroll-area";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogFooter,
    DialogTitle
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { DialogDescription } from '@radix-ui/react-dialog';

const schema = z.object({
    email: z.string().email().nonempty({message: "Required"}),
});

type AddSolverModalProps = {
    modalOpen: boolean;
    setModalOpen: Dispatch<SetStateAction<boolean>>;
    onSubmitHandler: (data: any) => Promise<void>;
}

const AddSolverModal: React.FC<AddSolverModalProps> = ({
    modalOpen: showAddModal,
    setModalOpen: hideAddModalHandler,
    onSubmitHandler
}) => {
    const formOptions = { resolver: zodResolver(schema) };
    const {
        register,
        handleSubmit,
        reset,
        formState
    } = useForm(formOptions);
    const { errors } = formState;

    useEffect(() => {
        if(showAddModal) {
            reset({
                id: ""
            });
        }
    }, [reset, showAddModal])

    return (
        <Dialog open={showAddModal} onOpenChange={hideAddModalHandler} defaultOpen={false}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>
                        Add Solver
                    </DialogTitle>
                    <DialogDescription>
                        Add a new solver to the project.
                    </DialogDescription>
                </DialogHeader>

                <ScrollArea className="max-h-[60vh] sm:max-h-[70vh]">
                    <div className="px-1 mb-3">
                        <InputFloating
                            label="Email"
                            register={register("email")}
                            errorMessage={errors["email"]?.message}
                            showError={true}
                            type='text'
                        />
                    </div>
                </ScrollArea>

                <DialogFooter>
                    <div className="flex items-stretch justify-end m-0 sm:space-x-2 max-sm:flex-col max-sm:space-y-2">
                        <Button size="sm" variant="secondary" onClick={hideAddModalHandler}>Cancel</Button>
                        <Button size="sm" onClick={handleSubmit(onSubmitHandler)}>Submit</Button>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default AddSolverModal;
